angular
  .module('core').filter('html', ['$sce', ($sce) => { // eslint-disable-line arrow-body-style
    return function html(item) {
      return $sce.trustAsHtml(item);
    };
  }]);



// WEBPACK FOOTER //
// ./src/app/core/filter/html.filter.js